/* eslint import/no-webpack-loader-syntax: off */
require('expose-loader?BVBanners!../../../src/globals/components/banners');
